export const LocalizedLabels = {
  'fr-BE': {
    documenteditor: {
      Table: 'Table',
      Row: 'Rangée',
      Cell: 'Cellule',
      Ok: "D'accord",
      Cancel: 'Annuler',
      Size: 'Taille',
      'Preferred Width': 'Largeur préférée',
      Points: 'Points',
      Percent: 'Pour cent',
      'Measure in': 'Mesurer en',
      Alignment: 'Alignement',
      Left: 'La gauche',
      Center: 'Centre',
      Right: 'Droite',
      Justify: 'Justifier',
      'Indent from left': 'Retrait de gauche',
      'Borders and Shading': 'Bordures et ombrage',
      Options: 'Les options',
      'Specify height': 'Précisez la hauteur',
      'At least': 'Au moins',
      Exactly: 'Exactement',
      'Row height is': 'La hauteur de ligne est',
      'Allow row to break across pages': 'Autoriser la ligne à traverser les pages',
      'Repeat as header row at the top of each page': "Répéter comme ligne d'en-tête en haut de chaque page",
      'Vertical alignment': 'Alignement vertical',
      Top: 'Haut',
      Bottom: 'Bas',
      'Default cell margins': 'Marges de cellule par défaut',
      'Default cell spacing': 'Espacement des cellules par défaut',
      'Allow spacing between cells': "Autoriser l'espacement entre les cellules",
      'Cell margins': 'Marges des cellules',
      'Same as the whole table': 'Identique à toute la table',
      Borders: 'Les frontières',
      None: 'Aucun',
      Style: 'Style',
      Width: 'Largeur',
      Height: 'la taille',
      Letter: 'Lettre',
      Tabloid: 'Tabloïde',
      Legal: 'Légal',
      Statement: 'Déclaration',
      Executive: 'Exécutif',
      A3: 'A3',
      A4: 'A4',
      A5: 'A5',
      B4: 'B4',
      B5: 'B5',
      'Custom Size': 'Format personnalisé',
      'Different odd and even': 'Différent impair et pair',
      'Different first page': 'Première page différente',
      'From edge': 'Du bord',
      Header: 'Entête',
      Footer: 'Bas de page',
      Margin: 'Marges',
      Paper: 'Papier',
      Layout: 'Disposition',
      Orientation: 'Orientation',
      Landscape: 'Paysage',
      Portrait: 'Portrait',
      'Show page numbers': 'Afficher les numéros de page',
      'Right align page numbers': 'Aligner à droite les numéros de page',
      Nothing: 'Rien',
      'Tab leader': 'Repère de tabulation',
      'Show levels': 'Afficher les niveaux',
      'Use hyperlinks instead of page numbers': 'Utilisez des hyperliens au lieu des numéros de page',
      'Build table of contents from': 'Créer une table des matières à partir de',
      Styles: 'modes',
      'Available styles': 'Styles disponibles',
      'TOC level': 'Niveau COT',
      Heading: 'Titre',
      'Heading 1': 'Rubrique 1',
      'Heading 2': 'Rubrique 2',
      'Heading 3': 'Rubrique 3',
      'Heading 4': 'Rubrique 4',
      'Heading 5': 'Rubrique 5',
      'Heading 6': 'Rubrique 6',
      'List Paragraph': 'Paragraphe de liste',
      Normal: 'Ordinaire',
      'Outline levels': 'Niveaux de contour',
      'Table entry fields': 'Champs de saisie de table',
      Modify: 'Modifier',
      Color: 'Couleur',
      Setting: 'Réglage',
      Box: 'Boîte',
      All: 'Tout',
      Custom: 'Douane',
      Preview: 'Aperçu',
      Shading: 'Ombres',
      Fill: 'Remplir',
      'Apply To': 'Postuler à',
      'Table Properties': 'Propriétés du tableau',
      'Cell Options': 'Options de cellule',
      'Table Options': 'Options de table',
      'Insert Table': 'Insérer un tableau',
      'Number of columns': 'Le nombre de colonnes',
      'Number of rows': 'Nombre de rangées',
      'Text to display': 'Texte à afficher',
      Address: 'Adresse',
      'Insert Hyperlink': 'Insérer un lien hypertexte',
      'Edit Hyperlink': "Modifier l'hyperlien",
      Insert: 'Insérer',
      General: 'Général',
      Indentation: 'Échancrure',
      'Before text': 'Avant le texte',
      Special: 'Spécial',
      'First line': 'Première ligne',
      Hanging: 'Pendaison',
      'After text': 'Après le texte',
      By: 'Par',
      Before: 'Avant',
      'Line Spacing': 'Interligne',
      After: 'Après',
      At: 'À',
      Multiple: 'Plusieurs',
      Spacing: 'Espacement',
      'Define new Multilevel list': 'Définir une nouvelle liste à plusieurs niveaux',
      'List level': 'Niveau liste',
      'Choose level to modify': 'Choisissez le niveau à modifier',
      Level: 'Niveau',
      'Number format': 'Format de nombre',
      'Number style for this level': 'Style de nombre pour ce niveau',
      'Enter formatting for number': 'Entrez la mise en forme du nombre',
      'Start at': 'Commencer à',
      'Restart list after': 'Redémarrez la liste après',
      Position: 'Position',
      'Text indent at': 'Retrait du texte à',
      'Aligned at': 'Aligné à',
      'Follow number with': 'Suivez le numéro avec',
      'Tab character': 'Caractère de tabulation',
      Space: 'Espace',
      Arabic: 'arabe',
      UpRoman: 'UpRoman',
      LowRoman: 'LowRoman',
      UpLetter: 'UpLetter',
      LowLetter: 'LowLetter',
      Number: 'Nombre',
      'Leading zero': 'Zéro en tête',
      Bullet: 'Balle',
      Ordinal: 'Ordinal',
      'Ordinal Text': 'Texte ordinal',
      'For East': "Pour l'Est",
      'No Restart': 'Pas de redémarrage',
      Font: 'Police de caractère',
      'Font style': 'Le style de police',
      'Underline style': 'Souligner le style',
      'Font color': 'Couleur de la police',
      Effects: 'Effets',
      Strikethrough: 'Barré',
      Superscript: 'Exposant',
      Subscript: 'Indice',
      'Double strikethrough': 'Barré double',
      Regular: 'Ordinaire',
      Bold: 'Audacieux',
      Italic: 'Italique',
      Cut: 'Couper',
      Copy: 'Copie',
      Paste: 'Pâte',
      Hyperlink: 'Hyperlien',
      'Open Hyperlink': "Ouvrir l'hyperlien",
      'Copy Hyperlink': "Copier l'hyperlien",
      'Remove Hyperlink': "Supprimer l'hyperlien",
      Paragraph: 'Paragraphe',
      'Linked Style': 'Lié (paragraphe et caractère)',
      Character: 'Personnage',
      'Merge Cells': 'Fusionner des cellules',
      'Insert Above': 'Insérer au-dessus',
      'Insert Below': 'Insérer ci-dessous',
      'Insert Left': 'Insérer à gauche',
      'Insert Right': 'Insérer à droite',
      Delete: 'Supprimer',
      'Delete Table': 'Supprimer le tableau',
      'Delete Row': 'Supprimer la ligne',
      'Delete Column': 'Supprimer la colonne',
      'File Name': 'Nom de fichier',
      'Format Type': 'Type de format',
      Save: 'sauvegarder',
      Navigation: 'La navigation',
      Results: 'Résultats',
      Replace: 'Remplacer',
      'Replace All': 'Remplace tout',
      'We replaced all': 'Nous avons remplacé tous',
      Find: 'Trouver',
      'No matches': 'Pas de correspondance',
      'All Done': 'Terminé',
      Result: 'Résultat',
      of: 'de',
      instances: 'instances',
      with: 'avec',
      'Click to follow link': 'Cliquez pour suivre le lien',
      'Continue Numbering': 'Continuer la numérotation',
      'Bookmark name': 'Nom du signet',
      Close: 'Fermer',
      'Restart At': 'Redémarrer à',
      Properties: 'Propriétés',
      Name: 'Nom',
      'Style type': 'Type de style',
      'Style based on': 'Style basé sur',
      'Style for following paragraph': 'Style pour le paragraphe suivant',
      Formatting: 'Mise en page',
      'Numbering and Bullets': 'Numérotation et puces',
      Numbering: 'Numérotage',
      'Update Field': 'Champ de mise à jour',
      'Edit Field': 'Modifier le champ',
      Bookmark: 'Signet',
      'Page Setup': 'Mise en page',
      'No bookmarks found': 'Aucun signet trouvé',
      'Number format tooltip information':
        "Format numérique à un niveau: </br> [PREFIX]% [LEVELNUMBER] [SUFFIX] </br> Par exemple, 'Chapitre% 1.' affichera la numérotation comme </br> Chapitre 1. Article </br> Chapitre 2. Article </br>… </br> Chapitre N. Article </br> </br> Format numérique à plusieurs niveaux: </br> [ PREFIX]% [LEVELNUMBER] [SUFFIX] + [PREFIX]% [LEVELNUMBER] [SUFFIX] </br> Par exemple, '% 1.% 2.' affichera la numérotation comme </br> 1.1. Article </br> 1.2. Article </br>… </br> 1.N. Article",
      Format: 'Format',
      'Create New Style': 'Créer un nouveau style',
      'Modify Style': 'Modifier le style',
      New: 'Nouveau',
      Bullets: 'Balles',
      'Use bookmarks': 'Utiliser des signets',
      'Table of Contents': 'Table des matières',
      AutoFit: 'Ajustement automatique',
      'AutoFit to Contents': 'Ajustement automatique au contenu',
      'AutoFit to Window': 'Ajustement automatique à la fenêtre',
      'Fixed Column Width': 'Largeur de colonne fixe',
      Reset: 'Réinitialiser',
      'Match case': 'Cas de correspondance',
      'Whole words': 'Mots entiers',
      Add: 'Ajouter',
      'Go To': 'Aller à',
      'Search for': 'Rechercher',
      'Replace with': 'Remplacer par',
      'TOC 1': 'TOC 1',
      'TOC 2': 'TOC 2',
      'TOC 3': 'TOC 3',
      'TOC 4': 'TOC 4',
      'TOC 5': 'TOC 5',
      'TOC 6': 'TOC 6',
      'TOC 7': 'TOC 7',
      'TOC 8': 'TOC 8',
      'TOC 9': 'TOC 9',
      'Right-to-left': 'De droite à gauche',
      'Left-to-right': 'De gauche à droite',
      Direction: 'Direction',
      'Table direction': 'Direction de la table',
      'Indent from right': 'Retrait à droite',
      'Contextual Spacing': "N'ajoutez pas d'espace entre les paragraphes des mêmes styles",
      'Password Mismatch': 'Le mot de passe ne correspond pas',
      'Restrict Editing': "Restreindre l'édition",
      'Formatting restrictions': 'Restrictions de formatage',
      'Allow formatting': 'Autoriser la mise en forme',
      'Editing restrictions': 'Modification des restrictions',
      'Read only': 'Lecture seulement',
      'Exceptions Optional': 'Exceptions (facultatif)',
      'Select Part Of Document And User':
        'Sélectionnez des parties du document et choisissez les utilisateurs autorisés à les modifier librement.',
      Everyone: 'Toutes les personnes',
      'More users': "Plus d'utilisateurs",
      'Add Users': 'Ajouter des utilisateurs',
      'Enforcing Protection': 'Oui, commencez à appliquer la protection',
      'Start Enforcing Protection': 'Commencer à appliquer la protection',
      'Enter User': "Entrez l'utilisateur",
      Users: 'Utilisateurs',
      'Enter new password': 'Entrez un nouveau mot de passe',
      'Reenter new password to confirm': 'Entrez à nouveau le nouveau mot de passe pour confirmer',
      'Your permissions': 'Vos autorisations',
      'Protected Document':
        'Ce document est protégé contre toute modification involontaire. Vous pouvez le modifier dans cette région.',
      FormFieldsOnly:
        'Ce document est protégé contre toute modification involontaire. Vous ne pouvez remplir des formulaires que dans cette région.',
      'You may format text only with certain styles': "Vous ne pouvez formater le texte qu'avec certains styles.",
      'Stop Protection': 'Arrêter la protection',
      Password: 'Mot de passe',
      'Spelling Editor': "Éditeur d'orthographe",
      Spelling: 'Orthographe',
      'Spell Check': 'Vérification orthographique',
      'Underline errors': 'Souligner les erreurs',
      Ignore: 'Ignorer',
      'Ignore All': 'Ignorer tout',
      'Add to Dictionary': 'Ajouter au dictionnaire',
      Change: 'Changement',
      'Change All': 'Change tout',
      Suggestions: 'Suggestions',
      'The password is incorrect': 'Le mot de passe est incorrect',
      'Error in establishing connection with web server':
        "Erreur lors de l'établissement de la connexion avec le serveur Web",
      'Highlight the regions I can edit': 'Mettez en surbrillance les régions que je peux modifier',
      'Show All Regions I Can Edit': 'Afficher toutes les régions que je peux modifier',
      'Find Next Region I Can Edit': 'Rechercher la prochaine région que je peux modifier',
      'Keep source formatting': 'Conserver le formatage source',
      'Match destination formatting': 'Faire correspondre la mise en forme de la destination',
      'Text only': 'Texte seulement',
      Comments: 'commentaires',
      'Type your comment': 'Tapez votre commentaire',
      Post: 'Publier',
      Reply: 'Répondre',
      'New Comment': 'Nouveau commentaire',
      Edit: 'Éditer',
      Resolve: 'Résoudre',
      Reopen: 'Rouvrir',
      'No comments in this document': 'Aucun commentaire dans ce document',
      more: 'plus',
      'Type your comment here': 'Tapez votre commentaire ici',
      'Next Comment': 'Commentaire suivant',
      'Previous Comment': 'Commentaire précédent',
      'Un-posted comments': 'Commentaires non publiés',
      'Discard Comment': 'Ajout de commentaires non publiés. Si vous continuez, ce commentaire sera ignoré.',
      'No Headings': 'Aucune rubrique trouvée!',
      'Add Headings': "Ce document n'a pas de titres. Veuillez ajouter des titres et réessayer.",
      'More Options': "Plus d'options",
      'Click to see this comment': 'Cliquez pour voir ce commentaire',
      'Drop Down Form Field': 'Champ de formulaire déroulant',
      'Drop-down items': 'Articles déroulants',
      'Items in drop-down list': 'Éléments dans la liste déroulante',
      ADD: 'AJOUTER',
      REMOVE: 'RETIRER',
      'Field settings': 'Réglages sur place',
      Tooltip: 'Info-bulle',
      'Drop-down enabled': 'Liste déroulante activée',
      'Check Box Form Field': 'Champ de formulaire de case à cocher',
      'Check box size': 'Cochez la taille',
      Auto: 'Auto',
      'Default value': 'Valeur par défaut',
      'Not checked': 'Non vérifié',
      Checked: 'Vérifié',
      'Check box enabled': 'Case à cocher activée',
      'Text Form Field': 'Champ de formulaire texte',
      Type: 'Type',
      'Default text': 'Texte par défaut',
      'Maximum length': 'Longueur maximale',
      'Text format': 'Format texte',
      'Fill-in enabled': 'Remplissage activé',
      'Default number': 'Numéro par défaut',
      'Default date': 'Date par défaut',
      'Date format': 'Format de date',
      'Merge Track': 'This action wont be marked as change. Do you want to continue?',
      UnTrack: 'Cannot be tracked',
      Accept: 'Accept',
      Reject: 'Reject',
      'Previous Changes': 'Previous Changes',
      'Next Changes': 'Next Changes',
      Inserted: 'Inserted',
      Deleted: 'Deleted',
      Changes: 'Changes',
      'Accept all': 'Accept all',
      'Reject all': 'Reject all',
      'No changes': 'No changes',
      'Accept Changes': 'Accept Changes',
      'Reject Changes': 'Reject Changes',
      User: 'Utilisateur',
      View: 'Vue',
      Insertion: 'Insertion',
      Deletion: 'Effacement',
      'All caps': 'Toutes en majuscules',
      'This region is locked by': 'Cette région est verrouillée par',
      Lock: 'Fermer à clé',
      Unlock: 'Ouvrir',
      'Already locked':
        'La région sélectionnée ou une partie de la région est déjà verrouillée par un autre utilisateur',
      '1, 2, 3, ...': '1, 2, 3, ...',
      'a, b, c, ...': 'a, b, c, ...',
      'A, B, C, ...': 'A, B, C, ...',
      'I, II, III, ...': 'I, II, III, ...',
      'i, ii, iii, ...': 'je, ii, iii, ...',
      'Text Form': 'Formulaire de texte',
      'Check Box': 'Case à cocher',
      DropDown: 'Menu déroulant',
      'Form Fields': 'Champs de formulaire',
      'Fillin enabled': 'Remplissage activé',
      'Multiple Comment': 'Veuillez poster votre commentaire',
      InsertFootnote: 'InsérerNote de bas de page',
      InsertEndnote: 'InsérerEndnote',
      Footnote: 'note de bas de page',
      Endnote: 'Note de fin de document',
      'Click to View/Edit Footnote': 'Cliquez pour afficher / modifier la note de bas de page',
      'Click to View/Edit Endnote': 'Cliquez pour afficher / modifier la note de fin',
      InsertAsRows: 'Insérer en tant que nouvelles lignes',
      InsertAsColumns: 'Insérer en tant que nouvelles colonnes',
      OverwriteCells: 'Écraser les cellules',
      NestTable: 'Table gigogne',
      'No suggestions': 'Pas de suggestions',
      'More Suggestion': 'Plus de suggestions',
      'Ignore Once': 'Ignorer une fois',
      'Keep With Next': 'Ignorer une fois',
      'Keep Lines Together': 'Continuer avec le suivant',
      WidowControl: 'Gardez les lignes ensemble',
      'Indents and Spacing': 'Contrôle des veuves/orphelins',
      'Line and Page Breaks': 'Retraits et espacement',
      Pagination: 'Sauts de ligne et de page',
      Single: 'Pagination',
      DashSmallGap: 'Seul',
      DashDot: 'DashSmallGap',
      Double: 'TiretPoint',
      ThinThickSmallGap: 'Double',
      ThickThinSmallGap: 'MinceÉpaisPetit Écart',
      ThickThinMediumGap: 'Épais MincePetit Écart',
      ThickThinLargeGap: 'ÉpaisMinceMoyenGap',
      SingleWavy: 'ÉpaisMinceLargeGap',
      DoubleWavy: 'SimpleOndulé',
      Inset: 'DoubleOndulé',
      DashLargeGap: 'Encart',
      Dot: 'DashLargeGap',
      DashDotDot: 'Point',
      Triple: 'TiretPointPoint',
      ThinThickThinSmallGap: 'Tripler',
      ThinThickThinMediumGap: 'MinceÉpais MincePetit Écart',
      ThinThickThinLargeGap: 'MinceÉpaisMinceMoyenÉcart',
      DashDotStroked: 'MinceÉpais MinceLargeGap',
      Engrave3D: 'DashDotCopé',
      Thick: 'Graver3D',
      Outset: 'Épais',
      Emboss3D: 'Début',
      ThinThickLargeGap: 'Emboss3D',
      ThinThickMediumGap: 'MinceÉpaisLargeGap',
      'Number of rows must be between 1 and 32767.': 'MinceÉpaisMoyenÉcart',
      'Number of columns must be between 1 and 63.': 'Le nombre de lignes doit être compris entre 1 et 32767.',
      'Ignore all': 'Ignorer tout',
      ok: 'Valider',
    },
    documenteditorcontainer: {
      New: 'Nouveau',
      Open: 'Ouvert',
      Undo: 'annuler',
      Redo: 'Refaire',
      Image: 'Image',
      Table: 'Table',
      Link: 'Lien',
      Bookmark: 'Signet',
      'Table of Contents': 'Table des matières',
      'HEADING - - - - 1': 'RUBRIQUE - - - - 1',
      'HEADING - - - - 2': 'RUBRIQUE - - - - 2',
      'HEADING - - - - 3': 'RUBRIQUE - - - - 3',
      Header: 'Entête',
      Footer: 'Bas de page',
      'Page Setup': 'Mise en page',
      'Page Number': 'Numéro de page',
      Break: 'Pause',
      Find: 'Trouver',
      'Local Clipboard': 'Presse-papiers local',
      'Restrict Editing': "Restreindre l'édition",
      'Upload from computer': "Télécharger d'un ordinateur",
      'By URL': 'Par URL',
      'Page Break': 'Saut de page',
      'Section Break': 'Saut de section',
      'Header And Footer': 'En-tête et pied de page',
      Options: 'Les options',
      Levels: 'Les niveaux',
      'Different First Page': 'Première page différente',
      'Different header and footer for odd and even pages':
        'En-tête et pied de page différents pour les pages paires et impaires.',
      'Different Odd And Even Pages': 'Pages paires et impaires différentes',
      'Different header and footer for first page': 'En-tête et pied de page différents pour la première page.',
      Position: 'Position',
      'Header from Top': 'En-tête du haut',
      'Footer from Bottom': 'Pied de page du bas',
      'Distance from top of the page to top of the header': "Distance du haut de la page au haut de l'en-tête.",
      'Distance from bottom of the page to bottom of the footer': 'Distance du bas de la page au bas du pied de page.',
      'Aspect ratio': "Ratio d'aspect",
      W: 'W',
      H: 'H',
      Width: 'Largeur',
      Height: 'la taille',
      Text: 'Texte',
      Paragraph: 'Paragraphe',
      Fill: 'Remplir',
      'Fill color': 'La couleur de remplissage',
      'Border Style': 'Style de bordure',
      'Outside borders': 'Hors frontières',
      'All borders': 'Toutes les frontières',
      'Inside borders': 'Frontières intérieures',
      'Left border': 'Bordure gauche',
      'Inside vertical border': 'Bordure verticale intérieure',
      'Right border': 'Bordure droite',
      'Top border': 'Bordure supérieure',
      'Inside horizontal border': 'Bordure horizontale intérieure',
      'Bottom border': 'Bordure inférieure',
      'Border color': 'Couleur de la bordure',
      'Border width': 'Largeur de la bordure',
      Cell: 'Cellule',
      'Merge cells': 'Fusionner des cellules',
      'Insert Or Delete': 'Insérer / supprimer',
      'Insert columns to the left': 'Insérer des colonnes à gauche',
      'Insert columns to the right': 'Insérer des colonnes à droite',
      'Insert rows above': 'Insérer des lignes au-dessus',
      'Insert rows below': 'Insérer des lignes ci-dessous',
      'Delete rows': 'Supprimer des lignes',
      'Delete columns': 'Supprimer des colonnes',
      'Cell Margin': 'Marge cellulaire',
      Top: 'Haut',
      Bottom: 'Bas',
      Left: 'La gauche',
      Right: 'Droite',
      'Align Text': 'Aligner le texte',
      'Align top': 'Aligner le haut',
      'Align bottom': 'Aligner en bas',
      'Align center': 'Aligner le centre',
      'Number of heading or outline levels to be shown in table of contents':
        'Nombre de niveaux de titre ou de plan à afficher dans la table des matières.',
      'Show page numbers': 'Afficher les numéros de page',
      'Show page numbers in table of contents': 'Afficher les numéros de page dans la table des matières.',
      'Right align page numbers': 'Aligner à droite les numéros de page',
      'Right align page numbers in table of contents':
        'Alignez à droite les numéros de page dans la table des matières.',
      'Use hyperlinks': 'Utilisez des hyperliens',
      'Use hyperlinks instead of page numbers': 'Utilisez des hyperliens au lieu des numéros de page.',
      Font: 'Police de caractère',
      'Font Size': 'Taille de police',
      'Font color': 'Couleur de la police',
      'Text highlight color': 'Couleur de surbrillance du texte',
      'Clear all formatting': 'Effacer toute mise en forme',
      'Bold Tooltip': 'Gras (Ctrl + B)',
      'Italic Tooltip': 'Italique (Ctrl + I)',
      'Underline Tooltip': 'Souligné (Ctrl + U)',
      Strikethrough: 'Barré',
      'Superscript Tooltip': 'Exposant (Ctrl + Shift ++)',
      'Subscript Tooltip': 'Indice (Ctrl + =)',
      'Align left Tooltip': 'Aligner à gauche (Ctrl + L)',
      'Center Tooltip': 'Centre (Ctrl + E)',
      'Align right Tooltip': 'Aligner à droite (Ctrl + R)',
      'Justify Tooltip': 'Justifier (Ctrl + J)',
      'Decrease indent': 'Diminuer le retrait',
      'Increase indent': 'Augmenter le retrait',
      'Line spacing': 'Interligne',
      Bullets: 'Balles',
      Numbering: 'Numérotage',
      Styles: 'modes',
      'Manage Styles': 'Gérer les styles',
      Page: 'Page',
      of: 'de',
      'Fit one page': 'Ajuster une page',
      'Spell Check': 'Vérification orthographique',
      'Underline errors': 'Souligner les erreurs',
      'Fit page width': 'Ajuster la largeur de la page',
      Update: 'Mise à jour',
      Cancel: 'Annuler',
      Insert: 'Insérer',
      'No Border': 'Pas de frontière',
      'Create a new document': 'Créez un nouveau document.',
      'Open a document': 'Ouvrez un document.',
      'Undo Tooltip': 'Annule la dernière opération (Ctrl + Z).',
      'Redo Tooltip': 'Refait la dernière opération (Ctrl + Y).',
      'Insert inline picture from a file': "Insérez une image en ligne à partir d'un fichier.",
      'Insert a table into the document': 'Insérer un tableau dans le document',
      'Create Hyperlink':
        'Créez un lien dans votre document pour un accès rapide aux pages Web et aux fichiers (Ctrl + K).',
      'Insert a bookmark in a specific place in this document':
        'Insérez un signet à un endroit spécifique de ce document.',
      'Provide an overview of your document by adding a table of contents':
        'Donnez un aperçu de votre document en ajoutant une table des matières.',
      'Add or edit the header': "Ajoutez ou modifiez l'en-tête.",
      'Add or edit the footer': 'Ajoutez ou modifiez le pied de page.',
      'Open the page setup dialog': 'Ouvrez la boîte de dialogue de mise en page.',
      'Add page numbers': 'Ajoutez des numéros de page.',
      'Find Text': 'Recherchez du texte dans le document (Ctrl + F).',
      'Toggle between the internal clipboard and system clipboard':
        "Basculez entre le presse-papiers interne et le presse-papiers système. </br> L'accès au presse-papiers système via un script est refusé en raison de la politique de sécurité des navigateurs. Au lieu de cela, </br> 1. Vous pouvez activer le presse-papiers interne pour couper, copier et coller dans le composant. </br> 2. Vous pouvez utiliser les raccourcis clavier (Ctrl + X, Ctrl + C et Ctrl + V) pour couper , copiez et collez avec le presse-papiers du système.",
      'Current Page Number':
        'Numéro de page actuel dans le document. Cliquez ou appuyez sur pour parcourir une page spécifique.',
      'Read only': 'Lecture seulement',
      Protections: 'Protections',
      'Error in establishing connection with web server':
        "Erreur lors de l'établissement de la connexion avec le serveur Web",
      Single: 'Célibataire',
      Double: 'Double',
      'New comment': 'Nouveau commentaire',
      Comments: 'commentaires',
      'Print layout': "Disposition d'impression",
      'Web layout': 'mise en page Web',
      'Text Form': 'Formulaire texte',
      'Check Box': 'Case à cocher',
      DropDown: 'Menu déroulant',
      'Update Fields': 'Champs de mise à jour',
      'Update cross reference fields': 'Mettre à jour les champs de référence croisée',
      'Hide properties pane': 'Masquer le volet des propriétés',
      'Show properties pane': 'Afficher le volet des propriétés',
      'Form Fields': 'Champs de formulaire',
      'Track Changes': 'Gardez une trace des modifications apportées au document',
      TrackChanges: 'Suivi des modifications',
      AllCaps: 'Toutes en majuscules',
      'Change case Tooltip': 'Changer de cas',
      'Insert Footnote': 'Insérer une note de bas de page',
      'Insert Endnote': 'Insérer une note de fin',
      'Footnote Tooltip': 'Insérer une note de bas de page (Alt + Ctrl + F).',
      'Endnote Tooltip': 'Insérer une note de fin (Alt + Ctrl + D).',
      UPPERCASE: 'MAJUSCULE',
      'No color': 'MAJUSCULE',
      'Top margin': 'Sans couleur',
      'Bottom margin': 'Marge supérieure',
      'Left margin': 'Marge inférieure',
      'Right margin': 'Marge de gauche',
      Normal: 'Marge de droite',
      Heading: 'Normal',
      'Heading 1': 'Titre',
      'Heading 2': 'Titre 1',
      'Heading 3': 'Titre 2',
      'Heading 4': 'Titre 3',
      'Heading 5': 'Titre 4',
      'Heading 6': 'Titre 5',
    },
  },
};
